export type SelectedModels = [string, string]

export const NO_MODEL = '' as const

export const NO_MODELS_SELECTED: SelectedModels = [NO_MODEL, NO_MODEL] as const
